import React from "react";

const Laundry = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-Laundry"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-Laundry"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m10.876,15.483c-.492.892-.517,1.169-.505,1.247.037.196.157.365.292.501.285.286.327.736.16,1.104-.281.619-1.102.788-1.58.306-.365-.368-.711-.875-.837-1.538-.167-.881.283-1.796.718-2.585.492-.892.517-1.169.505-1.247-.037-.196-.157-.365-.292-.501-.285-.286-.327-.736-.16-1.104.281-.619,1.102-.788,1.58-.306.365.368.711.875.837,1.538.167.881-.283,1.796-.718,2.585Zm4.718-2.585c-.126-.663-.471-1.17-.837-1.538-.478-.483-1.299-.313-1.58.306-.167.367-.125.817.16,1.104.135.136.255.305.292.501.012.078-.013.355-.505,1.247-.435.789-.885,1.705-.718,2.585.126.663.471,1.17.837,1.538.478.483,1.299.313,1.58-.306.167-.368.125-.818-.16-1.104-.135-.136-.255-.305-.292-.501-.012-.078.013-.355.505-1.247.435-.789.885-1.705.718-2.585Zm6.406-7.897v14c0,2.757-2.243,5-5,5H7c-2.757,0-5-2.243-5-5V5C2,2.243,4.243,0,7,0h10c2.757,0,5,2.243,5,5Zm-12-.5c0,.828.672,1.5,1.5,1.5s1.5-.672,1.5-1.5-.672-1.5-1.5-1.5-1.5.672-1.5,1.5Zm-3.5,1.5c.828,0,1.5-.672,1.5-1.5s-.672-1.5-1.5-1.5-1.5.672-1.5,1.5.672,1.5,1.5,1.5Zm11.5,9c0-3.309-2.691-6-6-6s-6,2.691-6,6,2.691,6,6,6,6-2.691,6-6Z" />
    </svg>
  );
};

export default Laundry;
